import './Tree.scss';

import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useState } from 'react';
import { memo } from 'react';
import { Collapse } from 'react-bootstrap';
import { TailSpin } from 'react-loader-spinner';
import classNames from 'classnames';
import IconButton from '../common/IconButton';
import { Alert, Tooltip } from 'antd';

export interface TreeElement {
  name: string;
  path: string;
  csvFilesPresent?: boolean;
  elements?: TreeElement[];
}

type Props = {
  elements?: any[];
  path?: string;
  selectedPath?: string;
  onSelect?: (path: string, jsonPath: string, csvFilesPresent?: boolean) => void;
  onBranchShow?: (path: string, jsonPath: string, empty: boolean) => void;
}

function Tree({ elements, onBranchShow, onSelect, path, selectedPath }: Props) {
  return (
    <div className="tree">
      {!elements && (
        <div className="p-2">
          <TailSpin
            height="30"
            width="30"
            color="#677ab1"
            radius="1"
          />
        </div>
      )}

      {elements?.length === 0 && <Alert type="info" showIcon message="No elements found." />}

      {elements?.map((el, index) => <TreeAccordion key={index} element={el} path={`${path ? path + "." : ""}${index}`} isBranch={el.isDir} onBranchShow={onBranchShow} onSelect={onSelect} selectedPath={selectedPath} />)}
    </div>
  )
}

type AccordionProps = {
  element: TreeElement;
  path: string;
  selectedPath?: string;
  isBranch?: boolean;
  onSelect?: (path: string, jsonPath: string, csvFilesPresent?: boolean) => void;
  onBranchShow?: (path: string, jsonPath: string, empty: boolean) => void;
}

const TreeAccordion = memo(({ element, path, isBranch, onBranchShow, selectedPath, onSelect }: AccordionProps) => {
  const [show, setShow] = useState(false);

  const toggleCollapse = () => {
    setShow(!show);
    onBranchShow?.(element.path, path + ".elements", !element.elements);
  }

  const handleSelect = () => onSelect?.(element.path, path, element.csvFilesPresent);

  return (
    <div className="tree-accordion">
      <div className="d-flex">
        <button type="button" className={classNames("accordion-toggle", { open: show, selected: element.path === selectedPath })} disabled={!isBranch} onClick={toggleCollapse}>
          {isBranch && <FontAwesomeIcon icon={show ? solid("folder-open") : solid("folder")} />}
          {!isBranch && <FontAwesomeIcon icon={solid("file")} />}
          <span className="ms-2">{element.name}</span>
          {isBranch && element.csvFilesPresent && (
            <Tooltip title="Table data">
              <FontAwesomeIcon className="text-muted ms-2" size="sm" icon={solid('table')} />
            </Tooltip>
          )}
        </button>

        {isBranch && (
          <IconButton className="ms-2 p-1" type="button" onClick={handleSelect} tooltip="Select element">
            <FontAwesomeIcon className={classNames({ "text-primary": element.path === selectedPath })} icon={element.path === selectedPath ? solid('check-circle') : regular('circle')} />
          </IconButton>
        )}
      </div>

      {isBranch && (
        <Collapse in={show}>
          <div>
            <div className="collapse-content">
              <Tree elements={element.elements} path={path + ".elements"} onBranchShow={onBranchShow} onSelect={onSelect} selectedPath={selectedPath} />
            </div>
          </div>
        </Collapse>
      )}
    </div>
  )
})

// Tree.Accordion = TreeAccordion;
export default memo(Tree);
